module.exports = __webpack_public_path__ + "img/slide1.39dd2c1b.jpg";;
if (typeof window !== 'undefined') {
(window.__IMAGE_SIZES__ || (window.__IMAGE_SIZES__ = {}))[module.exports] = {"width":634,"height":356,"variants":[{"file":"img/slide1-480w.058b9093cf4e.webp","width":480},{"file":"img/slide1-634w.6e53a1b16b70.webp","width":634}]};
}